(function () {
  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    var input = document.getElementById("search");
    var wrap = document.getElementById("tracking-search");
    var initial = document.getElementById("tracking-initial");
    var results = document.getElementById("tracking-results");
    var message = document.getElementById("no-count");

    if (!input || !initial || !results) return;

    var blogHandle = wrap && wrap.dataset.blogHandle ? wrap.dataset.blogHandle : "";
    var sectionName = "lgc-tracking-search-results";
    var timer = null;
    var form = input.closest("form");
    var notFoundMessage = (form && form.dataset.notFoundMessage) || "Submission eller ordrenummer kunne ikke findes.";
    var searchFailedMessage = (form && form.dataset.searchFailedMessage) || "Søgning fejlede. Prøv igen.";

    function setMessage(text) {
      if (message) message.textContent = text || "";
    }

    function showInitial() {
      initial.hidden = false;
      results.hidden = true;
      results.innerHTML = "";
      setMessage("");
    }

    function buildUrl(href, q) {
      var url = new URL(href, window.location.origin);
      url.searchParams.set("type", "article");
      url.searchParams.set("q", q);
      url.searchParams.set("sections", sectionName);
      if (blogHandle) url.searchParams.set("tracking_blog", blogHandle);
      return url.toString();
    }

    function fetchAndRender(href, q) {
      return fetch(buildUrl(href, q), { credentials: "same-origin" })
        .then(function (r) {
          return r.json();
        })
        .then(function (json) {
          results.innerHTML = json[sectionName] || "";
          results.hidden = false;
          initial.hidden = true;

          var any = results.querySelector(".submission-wrapper");
          setMessage(any ? "" : notFoundMessage);
        });
    }

    // Force correct default state
    showInitial();

    function onChange() {
      var q = (input.value || "").trim();
      window.clearTimeout(timer);

      if (!q) {
        showInitial();
        return;
      }

      timer = window.setTimeout(function () {
        fetchAndRender("/search", q).catch(function () {
          setMessage(searchFailedMessage);
        });
      }, 250);
    }

    input.addEventListener("input", onChange);
    input.addEventListener("search", onChange); // handles clicking the clear “x”
  });
})();
